import api from './api';

export const guidelinesService = {
    async get() {
        const response = await api.get('/guidelines');
        return response.data;
    },
    async update(body) {
        const response = await api.put('/guidelines', body);
        return response.data;
    },
};

export default guidelinesService;
